import React from 'react';
import { motion } from 'framer-motion';
export function ModulesGrid() {
  const categorias = [{
    id: 1,
    lightColor: 'bg-amber-500/15',
    borderColor: 'border-amber-500/40',
    textColor: 'text-amber-300',
    emoji: '🔧',
    title: 'APRENDÉ A SOLDAR DESDE CERO',
    subtitle: 'El sistema paso a paso para dominar la soldadura',
    desc: 'Técnicas, seguridad, tipos de soldadura, equipos y proyectos prácticos desde el día 1. Todo explicado para el contexto del taller argentino — sin tecnicismos innecesarios ni teoría vacía.',
    tags: ['EQUIPOS', 'TIPOS DE SOLDADURA', 'UNIONES', 'PRÁCTICAS', 'SEGURIDAD']
  }, {
    id: 2,
    lightColor: 'bg-amber-400/20',
    borderColor: 'border-amber-400/50',
    textColor: 'text-amber-300',
    emoji: '🔩',
    title: 'APRENDÉ TORNERÍA',
    subtitle: 'Desde lo básico hasta piezas de precisión',
    desc: 'Torno, herramientas, procesos, medición y prácticas reales. El complemento técnico que te abre trabajos que la mayoría de los herreros no pueden hacer.',
    tags: ['TORNO', 'HERRAMIENTAS', 'PROCESOS', 'MEDICIÓN', 'PRÁCTICAS']
  }, {
    id: 3,
    lightColor: 'bg-amber-700/20',
    borderColor: 'border-amber-700/40',
    textColor: 'text-amber-300',
    emoji: '🎨',
    title: 'HERRERÍA ARTÍSTICA',
    subtitle: 'Diseñá, forjá y creá piezas únicas con estilo propio',
    desc: 'Cómo diferenciarte de la competencia con trabajos artísticos que se cobran 3 veces más. Técnicas de forja, diseño y acabados que transforman hierro en arte que el mercado paga bien.',
    tags: ['DISEÑO', 'FORJA', 'TÉCNICAS', 'ACABADOS', 'PROYECTOS']
  }, {
    id: 4,
    lightColor: 'bg-amber-500/15',
    borderColor: 'border-amber-500/40',
    textColor: 'text-amber-300',
    emoji: '👨‍🏭',
    title: 'MAESTRO EN ACCIÓN',
    subtitle: 'Secretos, trucos y consejos de un herrero profesional',
    desc: 'Atajos que solo se aprenden con años de experiencia en el taller. Todo condensado para que vos lo apliques desde mañana mismo — sin cometer los errores que frenan a la mayoría.',
    tags: ['EXPERIENCIA', 'TRUCOS', 'CONSEJOS', 'PROYECTOS', 'MENTALIDAD']
  }, {
    id: 5,
    lightColor: 'bg-amber-400/20',
    borderColor: 'border-amber-400/50',
    textColor: 'text-amber-300',
    emoji: '✅',
    title: 'CHECK LIST — ANTES DE CORTAR',
    subtitle: 'Revisá · Medí · Planificá',
    desc: 'Evitá errores que cuestan plata. Ahorrá tiempo y material en cada trabajo. La herramienta práctica que usan los profesionales y que ningún principiante tiene — hasta ahora.',
    tags: ['PLANIFICACIÓN', 'MEDICIÓN', 'VERIFICACIÓN', 'SEGURIDAD', 'CORTE PERFECTO']
  }, {
    id: 6,
    lightColor: 'bg-amber-700/20',
    borderColor: 'border-amber-700/40',
    textColor: 'text-amber-300',
    emoji: '🪑',
    title: 'APOYO MUEBLES',
    subtitle: 'Diseños · Planos · Armado',
    desc: 'Muebles industriales resistentes y funcionales. Todo el material de apoyo visual y técnico para fabricar muebles que se venden solos en el mercado argentino de hoy.',
    tags: ['DISEÑOS', 'PLANOS', 'MATERIALES', 'ARMADO', 'ACABADOS']
  }];
  return <section className="py-20 bg-zinc-900" data-id="element-154">
      <div className="container mx-auto px-4" data-id="element-155">
        <div className="text-center mb-16" data-id="element-156">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-amber-400/15 text-amber-300 border border-amber-400/30 font-bold mb-6 text-[16px]" data-id="element-157">
            ⭐ MEGAPACK HERRERO ARGENTINO™
          </div>
          <h2 className="md:text-5xl font-extrabold text-white mb-4 text-[24px]" data-id="element-158">
            6 Módulos completos
          </h2>
          <p className="text-zinc-200 font-medium text-[16px]" data-id="element-159">
            Todo resuelto para herreros argentinos
          </p>
          <p className="text-amber-300 font-medium text-sm mt-2" data-id="element-160">
            📚 Un módulo por cada dimensión del oficio
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-161">
          {categorias.map((cat, i) => <motion.div key={cat.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="rounded-2xl border border-amber-900/40 bg-black/70 overflow-hidden shadow-lg hover:shadow-xl hover:border-amber-700/60 transition-all flex flex-col h-full" data-id="element-162">
              <div className={`${cat.lightColor} p-4 border-b ${cat.borderColor} flex items-center gap-3`} data-id="element-163">
                <div className="text-2xl" data-id="element-164">{cat.emoji}</div>
                <div data-id="element-165">
                  <p className={`text-xs font-bold uppercase tracking-wider ${cat.textColor}`} data-id="element-166">
                    Módulo {cat.id}
                  </p>
                  <h3 className="font-bold text-white text-lg leading-tight" data-id="element-167">
                    {cat.title}
                  </h3>
                </div>
              </div>
              <div className="p-6 flex-grow flex flex-col" data-id="element-168">
                <p className="font-semibold text-amber-200 mb-3 pb-3 border-b border-amber-900/30" data-id="element-169">
                  {cat.subtitle}
                </p>
                <p className="text-zinc-200 text-sm leading-relaxed mb-4" data-id="element-170">
                  {cat.desc}
                </p>
                <div className="mt-auto flex flex-wrap gap-1.5" data-id="element-171">
                  {cat.tags.map((tag, j) => <span key={j} className="text-[10px] font-bold uppercase tracking-wider bg-zinc-800 text-amber-400 px-2 py-1 rounded" data-id="element-172">
                      {tag}
                    </span>)}
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}